import { RoleValidator } from "../../../Components/Common";
import { ROLES } from "../../../Constants/Strings";
import { ADMIN_APPROVAL_BUTTONS, BILLING_COMPLETION_BUTTONS, INCHARGE_SUBMIT_BUTTONS, PGRN_STATUS } from "../constants";

// For Create or Edit-Draft (Inventory Incharge)
export const InchargeSubmitButtons = ({ handleSubmit }) => (
  <div className="flex gap-2 justify-end">
    {INCHARGE_SUBMIT_BUTTONS.map((btn) => (
      <RoleValidator key={btn.status} allowedRoles={ROLES.INVENTORY_INCHARGE}>
        <button
          onClick={() => handleSubmit(btn.status)}
          className="px-4 py-2 bg-primary hover:bg-blue-700 text-white block ml-2"
        >
          {btn.label}
        </button>
      </RoleValidator>
    ))}
  </div>
);

//For Admin Approval Flow (Pending Approval)
export const AdminApprovalButtons = ({ handleSubmit }) => (
  <div className="flex gap-2 justify-end">
    {ADMIN_APPROVAL_BUTTONS.map((btn) => (
      <RoleValidator key={btn.status} allowedRoles={ROLES.INVENTORY_ADMIN}>
        <button
          onClick={() => handleSubmit(btn.status)}
          className={`px-4 py-2 ${btn.color} text-white block ml-2`}
        >
          {btn.label}
        </button>
      </RoleValidator>
    ))}
  </div>
);

// NEW: Post-Approval Button (Incharge/Admin)
export const SendForProcurementButton = ({ handleSubmit }) => (
  <RoleValidator
    allowedRoles={[ROLES.INVENTORY_INCHARGE, ROLES.INVENTORY_ADMIN]}
  >
    <button
      onClick={() => handleSubmit(PGRN_STATUS.PENDING_PROCUREMENT_APPROVAL)}
      className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white ml-auto block"
    >
      Send for Procurement
    </button>
  </RoleValidator>
);

export const ProcurementActionButtons = ({ handleSubmit, status }) => (
  <div className="flex gap-2">
    <RoleValidator allowedRoles={ROLES.PROCUREMENT_INCHARGE}>
      <button
        onClick={() =>
          handleSubmit(
            status === PGRN_STATUS.PENDING_PROCUREMENT_APPROVAL
              ? PGRN_STATUS.PENDING_BILLING_APPROVAL
              : PGRN_STATUS.COMPLETED
          )
        }
        className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white ml-auto block"
      >
        {status === PGRN_STATUS.PENDING_PROCUREMENT_APPROVAL
          ? "Send to Billing"
          : "Mark as Completed"}
      </button>
    </RoleValidator>
  </div>
);

/*
Billing Completion (Incharge/Admin)
 */
export const BillingCompletionButtons = ({ handleSubmit }) => (
  <div className="flex gap-2 justify-end">
    {BILLING_COMPLETION_BUTTONS.map((btn) => (
      <RoleValidator
        allowedRoles={ROLES.BILLING_INCHARGE}
      >
        <button
          key={btn.status}
          onClick={() => handleSubmit(btn.status)}
          className={`px-4 py-2 ${btn.color} text-white block ml-2`}
        >
          {btn.label}
        </button>
      </RoleValidator>
    ))}
  </div>
);